import { Multilang, MultilangString } from "./multilang-string"
import { CaratechType, ITechRawData } from "../bo"
import { isNullOrEmpty, Languages } from "../../utils"
import { ITechFields } from "../../ui/product-form/_reducers/form-id-state"

interface IRawCaratech {
  codeEnum: string
  name: string
  lang: string
  value: string | MultilangString | boolean | number
  type: CaratechType
  valueCode?: string
  cle?: string
}

export const rawCaratechListConstructor = (
  techFields: ITechFields,
  caraTechParameters: ITechRawData[],
  caraTechOptions: any,
  lang: Languages
): IRawCaratech[] => {
  return Object.keys(techFields).reduce(
    (accumulator: IRawCaratech[], code: string) => {
      const techRawData = caraTechParameters.find((c) => c.codeEnum === code)
      if (!techRawData) {
        return accumulator
      }
      const { codeEnum, name, type } = techRawData
      let value = techFields[code].value

      // We remove declinable valueS as topRefs should not store those
      if (techFields[code].isDeclinable && Array.isArray(value)) {
        value = techFields[code].regenerateInfos.defaultValue
      }

      switch (type) {
        case "text":
          if (!Multilang.String.IsMultilangString(value)) {
            value = Multilang.String.CreateFrom(value, lang)
          }
          return (value as MultilangString)
            .map((val) =>
              rawCaratechConstructor(
                codeEnum,
                name,
                val.lang,
                CaratechType.text,
                val.value
              )
            )
            .filter((val) => !isNullOrEmpty(val.value))
            .concat(accumulator)

        case "select":
          const selected = caraTechOptions[code]
            ? caraTechOptions[code].find(
                (option: any) =>
                  option.value ===
                  (typeof value === "string" ? value : value.toString())
              )
            : ""
          const selectedValueCode = value
          const selectedValue = selected ? selected.text : "-"
          const selectedClePerigee = selected ? selected.cle : ""
          return [
            ...accumulator,
            rawCaratechConstructor(
              codeEnum,
              name,
              lang,
              type,
              selectedValue,
              selectedClePerigee,
              selectedValueCode
            ),
          ]

        default:
          return [
            ...accumulator,
            rawCaratechConstructor(codeEnum, name, lang, type, value),
          ]
      }
    },
    []
  )
}

export const rawCaratechConstructor = (
  codeEnum: string,
  name: string,
  lang: string,
  type: CaratechType,
  value: string,
  selectedClePerigee?: string,
  valueCode?: string
): IRawCaratech => ({
  codeEnum,
  name,
  lang,
  type,
  value: caratechValueToString(value),
  cle: selectedClePerigee,
  valueCode,
})

export const caratechValueToString = (value: any) => {
  switch (typeof value) {
    case "number":
      return `${value}`

    case "object":
      return JSON.stringify(value)

    default:
      return value
  }
}

export default IRawCaratech
